export default __webpack_public_path__ + "static/media/range.6227989d.svg";